import { render, staticRenderFns } from "./AliasInlineEditor.vue?vue&type=template&id=48e72167&scoped=true&"
import script from "./AliasInlineEditor.vue?vue&type=script&lang=js&"
export * from "./AliasInlineEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e72167",
  null
  
)

export default component.exports